import { savedOrderListHeaderStyles as headerStyles } from "@waytek/Overrides/Widgets/SavedOrderList/SavedOrderListHeader";
import { css } from "styled-components";

headerStyles.toggleFilterButton = {
    ...headerStyles.toggleFilterButton,
    buttonType: "outline",
    css: css`
        ${headerStyles.toggleFilterButton?.css}

        &&&:hover {
            &::after {
                content: none;
            }
        }
    `,
};
